import { getBrandFromHostname } from '../theme/brand';

let alreadyInitialized = false;

export function getHostedFrontendConfigValue(key: string): string | undefined {
  const hostname = window.location.hostname.trim().toLowerCase().replace(/\.+$/, '');
  if (
    !['API_URL', 'API_HOST', 'ARNOLD_URL', 'SELF_CARE_URL', 'COOKIE_DOMAIN'].includes(key) ||
    ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname)
  ) {
    return undefined;
  }

  const labels = hostname.split('.');
  const baseDomain = getBrandFromHostname(hostname) === 'pulser' ? 'pulsersurvey.com' : 'arnold-robot.com';
  const serviceDomain = [...labels.slice(1, -2), baseDomain].join('.');
  const values: Record<string, string> = {
    API_URL: `https://api.${serviceDomain}`,
    API_HOST: `api.${serviceDomain}`,
    ARNOLD_URL: `https://talk.${serviceDomain}`,
    SELF_CARE_URL: `https://admin.${serviceDomain}`,
    COOKIE_DOMAIN: baseDomain,
  };
  return values[key];
}

export function getFrontendConfigValue(key: string, defaultValue?: any) {
  if (!alreadyInitialized) {
    const feConfig = (window as any).FE_CONFIG;
    if (!feConfig || Object.keys(feConfig).length === 0) {
      setupLocalFrontendConfig();
    } else {
      alreadyInitialized = true;
    }
  }
  return getHostedFrontendConfigValue(key) ?? (window as any).FE_CONFIG?.[key] ?? defaultValue;
}

export function setupLocalFrontendConfig() {
  alreadyInitialized = true;
  (window as any).FE_CONFIG = {
    ...Object.entries(process.env).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key.replace(/^REACT_APP_/, '')]: value,
      }),
      {},
    ),
    // Cypress can switch the local frontends to its own API, see cypress/config/env.js in arnold-ui and self-care
    ...(window as any).Cypress?.env('FE_CONFIG'),
  };
}
